<template>
<div id="Detection">
    <section>
        <div class="container" id="title">
            <div class="row">
                <div class="col-sm-12">
                    <h2> {{detectioninfo.title}}</h2>
                    <hr>
                </div>
            </div>
        </div>
        <router-view></router-view>
    </section>
</div>
</template>

<script>
import DetectionInfo from '@/components/pages/DetectionInfo'
export default {
    name: "Detection",
    data(){
        return{
            detectioninfo: {
                title: '自我檢測',
            }
        }
    }
}
</script>

<style>
#title p{
    color: #fff
}

</style>


// WEBPACK FOOTER //
// src/components/pages/Detection.vue